module.exports = __webpack_public_path__ + "static/media/logo.9e7d6a7b.svg";